var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.3813C16.6294 21.3813 21.2847 16.7261 21.2847 11.0967C21.2847 5.45703 16.6294 0.812012 10.9897 0.812012C5.36035 0.812012 0.715332 5.45703 0.715332 11.0967C0.715332 16.7261 5.37061 21.3813 11 21.3813ZM11 20.0483C6.03711 20.0483 2.04834 16.0493 2.04834 11.0967C2.04834 6.13379 6.03711 2.13477 10.9897 2.13477C15.9526 2.13477 19.9517 6.13379 19.9619 11.0967C19.9619 16.0493 15.9629 20.0483 11 20.0483ZM8.14941 15.0342H9.1748C9.64648 15.0342 9.86182 14.7778 9.86182 14.3984V7.77441C9.86182 7.40527 9.64648 7.14893 9.1748 7.14893H8.14941C7.68799 7.14893 7.4624 7.40527 7.4624 7.77441V14.3984C7.4624 14.7778 7.68799 15.0342 8.14941 15.0342ZM12.8252 15.0342H13.8403C14.3018 15.0342 14.5273 14.7778 14.5273 14.3984V7.77441C14.5273 7.40527 14.3018 7.14893 13.8403 7.14893H12.8252C12.3535 7.14893 12.1382 7.40527 12.1382 7.77441V14.3984C12.1382 14.7778 12.3535 15.0342 12.8252 15.0342Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseOutline);
export default __webpack_public_path__ + "static/media/Pause-outline.4b829a3c30bfa82d4cf3b8959698eed4.svg";
export { ForwardRef as ReactComponent };